import { Controller } from "@hotwired/stimulus"

// Picks a Font Awesome glyph: writes the chosen name into a hidden input, mirrors
// it into a preview <i>, and highlights the active swatch.
export default class extends Controller {
  static targets = ["input", "preview", "previewImage", "removeCheckbox", "button"]

  connect() {
    this.highlight(this.hasInputTarget ? this.inputTarget.value : null)
  }

  select(event) {
    const name = event.currentTarget.dataset.icon
    if (!this.hasInputTarget) return
    this.inputTarget.value = name
    if (this.hasPreviewTarget) {
      this.previewTarget.className = `fa fa-${name}`
      this.previewTarget.style.display = ""
    }
    // Picking a glyph means the uploaded image should give way to it.
    if (this.hasPreviewImageTarget) this.previewImageTarget.style.display = "none"
    if (this.hasRemoveCheckboxTarget) this.removeCheckboxTarget.checked = true
    this.highlight(name)
  }

  highlight(name) {
    this.buttonTargets.forEach(btn => {
      btn.classList.toggle("btn-primary", btn.dataset.icon === name)
      btn.classList.toggle("btn-outline-secondary", btn.dataset.icon !== name)
    })
  }
}
